import {
  FULFILLMENT_STATUS,
  ORDER_STATUS,
  USER_ROLES,
} from '../../common/constants';

export const ORDER_ITEM_STAFF_ROLES = {
  PICKER: { ...USER_ROLES?.PICKER, field: 'picker' },
  PACKER: { ...USER_ROLES?.PACKER, field: 'packer' },
};

export const REASSIGNABLE_ITEM_STATUSES = [
  ORDER_STATUS?.PLACED?.value,
  FULFILLMENT_STATUS?.UNIT_MAPPED?.value,
];

export const formatStaffName = (user) =>
  user?.firstName || user?.lastName || user?.userNumber
    ? `${user?.firstName || ''} ${user?.lastName || ''}${
        user?.userNumber ? ` (${user?.userNumber})` : ''
      }`?.trim()
    : '-';

export const isReassignableOrderItem = (orderItem) =>
  REASSIGNABLE_ITEM_STATUSES.includes(orderItem?.status);

export const DIFFERENT_LIBRARIES_MESSAGE =
  'Selected orders belong to different libraries. Select orders of a single library to assign picker / packer.';

export const ROLE_LOCKED_ITEM_STATUSES = {
  [USER_ROLES?.PICKER?.key]: [FULFILLMENT_STATUS?.UNIT_MAPPED?.value],
};

export const ROLE_LOCKED_MESSAGES = {
  [USER_ROLES?.PICKER?.key]: 'Item already picked',
};

export const isRoleLockedForItem = (orderItem, roleKey) =>
  Boolean(ROLE_LOCKED_ITEM_STATUSES?.[roleKey]?.includes(orderItem?.status));

export const canAssignRoleToItem = (orderItem, roleKey) =>
  isReassignableOrderItem(orderItem) &&
  !isRoleLockedForItem(orderItem, roleKey);

export const BULK_ROLE_LOCKED_NOTES = {
  [USER_ROLES?.PICKER
    ?.key]: 'Items that are already picked are skipped, their picker will not change.',
};

export const BULK_ROLE_LOCKED_EMPTY_MESSAGES = {
  [USER_ROLES?.PICKER
    ?.key]: 'All selected items are already picked, so their picker can not be changed.',
};
